import React from "react";
import Modal from "components/Modal/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import ModalFooterLeft from "components/Modal/ModalFooterLeft";
import Button from "components/Button/Button";
import LoaderSection from "components/LoaderSection";
import { httpClient } from "common/httpClient";

const AddCardModal = ({ close }) => {
    const [payment, setPayment] = React.useState();
    const [inProgress, setInProgress] = React.useState(false);

    // Access the data from the mutation
    React.useEffect(() => {
        const fetchPayment = async () => {
            try {
                const response = await httpClient.post(`payments/addPaystationToken`, { redirectUrl: `${window.location.origin}/#/tokenresponse` });
                if (response && response.paymentUrl) {
                    setPayment(response);
                } else {
                    console.error("Failed to retrieve payment URL");
                }
            } catch (error) {
                console.error("Error fetching payment data:", error);
            }
        };

        if (!payment) {
            fetchPayment();
        }
    }, [payment]);

    React.useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.type === "PROCESSING_COMPLETE") {
                close();
            } else if (event.data?.type === "TOKEN_INPROGRESS") {
                setInProgress(true);
            }
        };
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [close]);

    return (
        <Modal title="Add credit card" skinny close={close} showHeaderActions={!inProgress} instructionText="Please keep this window open. Once your card has been saved the window will close automatically.">
            <ModalBody>
                {payment && payment.paymentUrl ? (
                    <iframe id="paymentFrame" src={`${payment.paymentUrl}&b=FFFFFF`} title="Paystation" className="paystation-payment-frame u-mt-lg" />
                ) : (
                    <div className="u-mt-xl">
                        <LoaderSection message="Contacting our 3rd party payment provider..." dark />
                    </div>
                )}
            </ModalBody>
            {!inProgress && (
                <ModalFooter>
                    <ModalFooterLeft>
                        <Button id="close" onClick={close} secondary>
                            Close
                        </Button>
                    </ModalFooterLeft>
                </ModalFooter>
            )}
        </Modal>
    );
};
export default AddCardModal;
